import { agileGetEmail, agileIsKnown } from './agileHelper.js';
import Ani from './Ani.js';

export function werkboekenInit() {
    const viewButtons = [...document.querySelectorAll('[data-werkboeken~="view"]')];

    if (viewButtons.length == 0) {
        return;
    }

    document.body.addEventListener('load-blog-posts-success', (e) => {
        eventListenersButtons();
    });
    eventListenersButtons();

    document.body.addEventListener('agile-success', (e) => {
        toGoWerkboeken();
    });

    const popUp = document.getElementById('overlay-werkboeken');

    if (popUp) {
        popUp.addEventListener('click', (e) => {
            if (e.target !== popUp) {
                return;
            }
            e.preventDefault();
            Ani.fadeOut(popUp);
        });
    }
}

function eventListenersButtons() {
    const viewButtons = [...document.querySelectorAll('[data-werkboeken~="view"]')];
    viewButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            // We set the intended werkboek in the session storage, to be used after the agile form is filled in
            sessionStorage.setItem('intended_werkboek', button.dataset.id);
            sessionStorage.setItem('intended_tags', button.dataset.tags);

            if (agileIsKnown()) {
                console.log('known');
                toGoWerkboeken();
            } else {
                const popUp = document.getElementById('overlay-werkboeken');

                Ani.fadeIn(popUp);
            }
        });
    });
}

function toGoWerkboeken() {
    console.log('werk');
    const popUp = document.getElementById('overlay-werkboeken');

    Ani.fadeOut(popUp);
    if (sessionStorage.getItem('intended_werkboek') == null) {
        return;
    }

    // We go to a dummy route which is handled by the router
    window.open(
        '/werkboeken/gate/' + sessionStorage.getItem('intended_werkboek') + '?email=' + agileGetEmail(),
        '_blank'
    );

    sessionStorage.removeItem('intended_werkboek');
}
